import { useTranslation } from "react-i18next";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { useNavigate } from "react-router-dom";
import LogoWhite from "../../assets/img/logo_white.svg";

const ItemThumbs = ({ item, height }) => {
  let navigate = useNavigate();
  const { t } = useTranslation();

  return item.itemPictures?.length > 0 ? (
    <Carousel
      showThumbs={false}
      showStatus={false}
      showIndicators={item.itemPictures?.length > 1}
      className="h-full w-full overflow-hidden flex items-center"
    >
      {item.itemPictures.map((picture, key) => (
        <div
          className={`cursor-pointer h-${height}`}
          key={key}
          onClick={() => navigate("/items/" + item.id)}
        >
          <img
            className="h-full w-full object-cover object-center"
            src={
              process.env.REACT_APP_API_URL +
              "/uploads/thumb_" +
              picture.filePath
            }
          />
        </div>
      ))}
    </Carousel>
  ) : (
    <div
      className={`h-${height} cursor-pointer text-gray-400 duration-200 text-xs w-full h-full bg-gray-100 hover:bg-gray-50 flex items-center justify-center`}
      onClick={() => navigate("/items/" + item.id)}
    >
      <img className="w-full mx-6 object-cover object-center" src={LogoWhite} />
    </div>
  );
};

export default ItemThumbs;
